<template>
  <div style="clear: both;">
    <div class="wrapper">
      <div class="pic-wrapper">
        <img src="./../assets/IP_geschenk_sketch01_preview.png" alt="">
      </div>
      <div class="text-wrapper">
        <h4>Kostenfrei</h4>
        <p>Das Angebot der wöchentlichen Achtsamkeitsübungen ist kostenfrei und wird es auch bleiben.</p>
      </div>
    </div>
    <div class="wrapper">
      <div class="pic-wrapper">
        <img src="./../assets/IP_laterne_sketch01_preview.png" alt="">
      </div>
      <div class="text-wrapper">
        <h4>Jederzeit abmeldbar</h4>
        <p>Du kannst jederzeit die wöchentlichen Übungen abbestellen. Sollte es dazu kommen würden wir uns über ein kurzes Feedback zu deiner Abmeldung freuen.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  img {
    width: 100px;
    height: auto;
    position: absolute;
    top: -10px;
    left: 0px;
    mix-blend-mode: multiply;
  }
  .wrapper {
    width: 50%;
    float: left;
  }

  .pic-wrapper {
    position: relative;
    width: 100px;
    height: 100px;
    background-color: #88C6BC;
    float: left;
    border-radius: 50%;
    margin: 20px;
  }

  .text-wrapper {
    float: left;
    padding: 10px;
    width: calc(100% - 160px);
  }

  .text-wrapper  h4, p {
    margin: 0px;
  }

  @media screen and (max-width: 500px) {
    .wrapper {
      text-align: center;
    }
    .pic-wrapper {
      display: inline-block;
      float: none;
    }
    .text-wrapper {
      width: 100%;
      padding: 0px;
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 960px) {
    .wrapper {
      width: 100%;
    }
  }
</style>
